import React from 'react';

export const CustomAuthenticatingError = () => {
    return (
        <div>
            <h1 className="css_heading bold">Authentication Error</h1>
            <p>An error occurred during authentication. Please close and restart your browser.</p>
        </div>
    );
}

export default CustomAuthenticatingError;